
import { Vue, Component, Prop } from "vue-property-decorator";
import {Getter} from "vuex-class";
import "vue-datetime/dist/vue-datetime.css";
import SimpleDialog from "@/components/SimpleDialog.vue";

@Component({
  components: { SimpleDialog },
})
export default class MissionOrderUnassignModal extends Vue {

    @Prop({default: null})
    public missionOrderId: number;

    @Getter private isMobile: boolean;
    @Getter private envCompanyId: number|null;

    private showDialog: boolean = true;
    private loading: boolean = false;

    private mounted(): void {
      //
    }

    private cancel(): void {
      this.showDialog = false;
      this.$emit("close");
    }

    private async confirm(): Promise<void> {
      await this.unassignMissionOrder();
    }

    private async unassignMissionOrder(): Promise<void> {
        this.loading = true;
        await this.$store.dispatch("missionOrders/assign", {
            id: this.missionOrderId,
            userGroupId: null,
        }).then(() => {
            this.showDialog = false;
            this.$store.commit("alerts/displaySuccess", {
              msg: this.$i18n.t("MissionOrders.unassign.success"),
            });
            this.$emit("reset");
        }).catch((error) => {
            this.$store.commit("alerts/displayHttpError", { error });
        }).finally(() => {
            this.loading = false;
        });
    }
}
